import { render } from "./SysteAdvisorySection.vue?vue&type=template&id=054b5a04"
import script from "./SysteAdvisorySection.vue?vue&type=script&lang=js"
export * from "./SysteAdvisorySection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__